'use strict';
var parent = require('../../stable/object/define-properties');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/define-properties.js
// module id = 542
// module chunks = 13